module.exports = __webpack_public_path__ + "static/media/filter-4.3c3111c8.png";